import { type FunctionComponent } from "react";

import buildSoftIcon from "images/Common/buildSoft.png";

import { type IBTIconProps } from "../BTIcon.types";

export const BTIconDeprecatedBuildsoft: FunctionComponent<IBTIconProps> = (baseProps) => {
    return (
        <img alt="" src={buildSoftIcon} style={baseProps.style} className={baseProps.className} />
    );
};
